<template>
    <ListPVApproval platform="pv_lm" nameTable="lm---lease-management-payment-voucher"/>
</template>
<script>
    const ListPVApproval = () => import('./list-pv-approval')
    export default {
        name: 'list-pv-approval-lm',
        components: {
            ListPVApproval
        }
    }
</script>
